import {
  Smartphone,
  Pencil,
  Clock3,
  Receipt,
  AlertTriangle,
  PackageX,
  CalendarDays,
  Megaphone,
  FileText,
  CircleStop,
  PauseCircle,
  LayoutGrid,
  MessageCircle,
} from "../../../ui/icons";

export const SUPPORT_CATEGORY_ICONS = {
  app_issue: Smartphone,

  menu_update: Pencil,

  working_hours: Clock3,

  invoice_request: Receipt,

  rider_issue: AlertTriangle,

  product_out_of_stock: PackageX,

  meeting_request: CalendarDays,

  offer_request: Megaphone,

  statement_request: FileText,

  stop_request: CircleStop,

  pause_request: PauseCircle,

  registration_request: LayoutGrid,

  other: MessageCircle,
};

export const DEFAULT_SUPPORT_ICON =
  MessageCircle;